import React, { memo, useEffect, useRef, useState } from 'react';
import ReactECharts from 'echarts-for-react';

import * as _ from 'lodash';
import { mapIndexList } from 'utils/config';
import { log } from 'utils';

const appUrl = `${process.env.REACT_APP_ALGO_API_URL}`;

export function usePrevious(value) {
  const ref = useRef();

  useEffect(() => {
    ref.current = value;
  }, [value]); // Only re-run if value changes

  return ref.current;
}

function ChartForeignBS(props) {
  const abortController = new AbortController();

  const DEFAULT_OPTION = {
    grid: { top: 8, right: 35, bottom: 20, left: 10 },
    xAxis: {
      type: 'category',
      boundaryGap:false,
      data: [],
      // splitNumber: 5,
      // minInterval: 3600 * 1000,
      axisLine: {
        show: false,
      },
      splitLine: {
        show: true,
        lineStyle: {
          type: 'dashed',
          color: '#4E4D62',
          dashOffset: 10,
          opacity: 0.3,
        },
      },
      axisTick: {
        show: false,
        alignWithLabel: false,
        length: 3,
      },
      axisLabel: {
        color: '#83817C',
        fontSize: 8,
        formatter: function (value, index) {
          const arr = value.split(':');
          return arr[0] + ':' + arr[1];
        },
        // width: 100,
        // overflow: 'truncate',
        interval: 60,
        borderColor: '#ECECEC',
        showMinLabel: true,
        showMaxLabel: true,
      },
    },
    yAxis: {
      type: 'value',
      show: true,
      position: 'right',
      alignTicks: true,
      splitNumber: 4,
      //   axisLine: {
      //     show: true,
      //     lineStyle: {
      //         type: 'dashed',
      //         color: '#4E4D62'
      //     }
      //   },
      splitLine: {
        // show: false,
        lineStyle: {
          type: 'dashed',
          color: '#4E4D62',
          dashOffset: 10,
          opacity: 0.3,
        },
      },
      axisLabel: {
        formatter: (val) =>
          `${Math.abs(val) >= 1000000 ? val / 1000000 : Math.abs(val) >= 1000 ? val / 1000 : val}${
            Math.abs(val) >= 1000000 ? 'M' : Math.abs(val) >= 1000 ? 'K' : ''
          }`,
        color: '#83817C',
        fontSize: 8,
        showMinLabel: false,
        showMaxLabel: false,
      },
    },
    series: [
      {
        type: 'line',
        smooth: true,
        symbol: 'none',
        sampling: 'lttb',
        itemStyle: {
          color: '#03CAA6',
        },
        lineStyle: {
          width: 1,
        },
        areaStyle: {
          color: '#20CA78',
        },
        data: [],
      },
    ],
    tooltip: false,
  };

  const [option, setOption] = useState(DEFAULT_OPTION);

  const { symActive, algoIChart } = props;
  const preAlgoIChart = usePrevious(algoIChart);

  useEffect(() => {
    _handleLoadDataStock();

    // const timer = setInterval(() => {
    //   fetchNewData();
    // }, 5 * 60 * 1000);

    return () => {
      // clearInterval(timer);
      abortController.abort();
    };
  }, []);

  useEffect(() => {
    if(algoIChart && !_.isEqual(algoIChart, preAlgoIChart))
      processRealtime(algoIChart)
  }, [algoIChart]);

  function fetchNewData() {
    let hour = new Date().getHours();
    // console.log(hour)
    if (hour < 8 || hour >= 15) return;
    _handleLoadDataStock();
  }

  function _handleLoadDataStock() {
    if (!symActive) return;
    fetch(appUrl + 'pbapi/api/stockBoard/chart/index/' + mapIndexList[symActive],
    {
      signal: abortController.signal,
    })
      .then((response) => response.json())
      .then((res) => {
        // log(res)
        _mapDataToState(_.filter(res.data, o => o.FGBuyValue > 0));
      })
      .catch((error) => {
        // log(error);
      });
  }

  function _mapDataToState(dt) {
    const newOption = _.cloneDeep(option);

    // const _rand = Math.random() - 0.5;

    const yAxis = _.map(dt, o => o.FGBuyValue);
    const xAxis = _.map(dt, 'Time');

    const _min = _.min(yAxis);
    const _max = _.max(yAxis);

    // console.log(dt)

    newOption.xAxis.data = xAxis;
    newOption.yAxis.min = _min;
    newOption.yAxis.max = _max;
    newOption.series[0].data = yAxis;

    const _lastChange = dt[dt.length - 1].FGBuyValue;

    if(_lastChange > 0){
      //up
      newOption.series[0].itemStyle.color = '#0FC786';
      newOption.series[0].areaStyle.color = '#0FC786';
    } else {
      // down
      newOption.series[0].itemStyle.color = '#F5465C';
      newOption.series[0].areaStyle.color = '#F5465C';
    }

    console.log(newOption);

    setOption(newOption);
  }

  
  function processRealtime(record) {
    if(_.isArray(record) && record.length > 0 && record[0] === mapIndexList[symActive]){
      const newOption = _.cloneDeep(option);
      console.log(newOption)
      let xAxis = newOption.xAxis.data;
      let yAxis = newOption.series[0].data;

      // time
      xAxis.push(record[1])
      // data
      yAxis.push(record[5])
      const _min = _.min(yAxis);
      const _max = _.max(yAxis);
      newOption.yAxis.min = _min;
      newOption.yAxis.max = _max;
      newOption.series[0].data = yAxis;

      setOption(newOption);
    }
  }

  return (
    <ReactECharts
      option={option}
      style={{
        height: '100%',
        width: `100%`,
      }}
    />
  );
}

export default memo(ChartForeignBS);
